import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpandSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="expand-simple"><path d="M5.75 12.75V18.25H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 5.75H18.25V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconExpandSimple;
